// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { ScheduleIntervalDetailsFragmentDoc } from '../../../fragments/circularFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ScheduleExportPageQueryVariables = Types.Exact<{
  scheduleId: Types.Scalars['ID']['input'];
  startDate: Types.Scalars['Date']['input'];
  endDate: Types.Scalars['Date']['input'];
  tradePartnerIds?: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>;
  scheduleSubPhaseIds?: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>;
  limit: Types.Scalars['Int']['input'];
}>;


export type ScheduleExportPageQuery = { __typename?: 'Query', schedules: Array<{ __typename?: 'Schedule', id: string, stage: Types.Stage, parent:
      | { __typename?: 'StandaloneProject', id: string, name: string }
      | { __typename?: 'Region', id: string, name: string }
      | { __typename?: 'Development', id: string, name: string }
      | { __typename?: 'Market', id: string, name: string }
      | { __typename?: 'Community', id: string, name: string }
      | { __typename?: 'Subdivision', id: string, name: string }
      | { __typename?: 'Lot', id: string, name: string }
      | { __typename?: 'Structure', id: string, name: string }
      | { __typename?: 'Unit', id: string, name: string }
      | { __typename?: 'ScheduleTemplate', id: string, name: string }
    , phases: Array<{ __typename?: 'SchedulePhase', id: string, name: string, scheduleSubPhases: Array<{ __typename?: 'ScheduleSubPhase', id: string, name: string, interval?: { __typename?: 'CalendarInterval', startDate: Types.Scalars['Date']['input'], endDate: Types.Scalars['Date']['input'], durationInDays: number } | null | undefined }>, globalPhase: { __typename?: 'GlobalPhase', id: string, displayOrder?: number | null | undefined }, interval?: { __typename?: 'CalendarInterval', startDate: Types.Scalars['Date']['input'], endDate: Types.Scalars['Date']['input'], durationInDays: number } | null | undefined }> }>, scheduleTasks: Array<{ __typename?: 'ScheduleTask', id: string, name: string, isCriticalPath: boolean, schedulePhase?: { __typename?: 'SchedulePhase', id: string } | null | undefined, scheduleSubPhase?: { __typename?: 'ScheduleSubPhase', id: string } | null | undefined, interval: { __typename?: 'CalendarInterval', startDate: Types.Scalars['Date']['input'], endDate: Types.Scalars['Date']['input'], durationInDays: number }, assignee?: { __typename?: 'InternalUser', id: string, name: string } | null | undefined, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined, predecessorDependencies: Array<{ __typename?: 'ScheduleTaskDependency', id: string, lagInDays: number, predecessor: { __typename?: 'ScheduleTask', id: string } }>, successorDependencies: Array<{ __typename?: 'ScheduleTaskDependency', id: string, lagInDays: number, successor: { __typename?: 'ScheduleTask', id: string } }> }> };

export type ScheduleExportPhasesFragment = { __typename?: 'SchedulePhase', id: string, name: string, globalPhase: { __typename?: 'GlobalPhase', id: string, displayOrder?: number | null | undefined }, interval?: { __typename?: 'CalendarInterval', startDate: Types.Scalars['Date']['input'], endDate: Types.Scalars['Date']['input'], durationInDays: number } | null | undefined };

export type ScheduleExportSubPhaseFragment = { __typename?: 'ScheduleSubPhase', id: string, name: string, interval?: { __typename?: 'CalendarInterval', startDate: Types.Scalars['Date']['input'], endDate: Types.Scalars['Date']['input'], durationInDays: number } | null | undefined };

export type ScheduleExportTaskFragment = { __typename?: 'ScheduleTask', id: string, name: string, isCriticalPath: boolean, interval: { __typename?: 'CalendarInterval', startDate: Types.Scalars['Date']['input'], endDate: Types.Scalars['Date']['input'], durationInDays: number }, assignee?: { __typename?: 'InternalUser', id: string, name: string } | null | undefined, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined, predecessorDependencies: Array<{ __typename?: 'ScheduleTaskDependency', id: string, lagInDays: number, predecessor: { __typename?: 'ScheduleTask', id: string } }>, successorDependencies: Array<{ __typename?: 'ScheduleTaskDependency', id: string, lagInDays: number, successor: { __typename?: 'ScheduleTask', id: string } }> };

export const ScheduleExportPhasesFragmentDoc = gql`
    fragment ScheduleExportPhases on SchedulePhase {
  id
  name
  globalPhase {
    id
    displayOrder
  }
  interval {
    ...ScheduleIntervalDetails
  }
}
    ${ScheduleIntervalDetailsFragmentDoc}`;
export const ScheduleExportSubPhaseFragmentDoc = gql`
    fragment ScheduleExportSubPhase on ScheduleSubPhase {
  id
  name
  interval {
    ...ScheduleIntervalDetails
  }
}
    ${ScheduleIntervalDetailsFragmentDoc}`;
export const ScheduleExportTaskFragmentDoc = gql`
    fragment ScheduleExportTask on ScheduleTask {
  id
  name
  interval {
    ...ScheduleIntervalDetails
  }
  assignee {
    id
    name
  }
  tradePartner {
    id
    name
  }
  isCriticalPath
  predecessorDependencies {
    id
    lagInDays
    predecessor {
      id
    }
  }
  successorDependencies {
    id
    lagInDays
    successor {
      id
    }
  }
}
    ${ScheduleIntervalDetailsFragmentDoc}`;
export const ScheduleExportPageDocument = gql`
    query ScheduleExportPage($scheduleId: ID!, $startDate: Date!, $endDate: Date!, $tradePartnerIds: [ID!], $scheduleSubPhaseIds: [ID!], $limit: Int!) {
  schedules(filter: {id: [$scheduleId]}) {
    id
    stage
    parent {
      ... on Project {
        id
        name
      }
      ... on ScheduleTemplate {
        id
        name
      }
      ... on Development {
        id
        name
      }
    }
    phases {
      ...ScheduleExportPhases
      scheduleSubPhases {
        ...ScheduleExportSubPhase
      }
    }
  }
  scheduleTasks(
    filter: {schedule: [$scheduleId], startDateRange: {op: BETWEEN, value: $startDate, value2: $endDate}, endDateRange: {op: BETWEEN, value: $startDate, value2: $endDate}, tradePartner: $tradePartnerIds, scheduleSubPhase: $scheduleSubPhaseIds}
    first: $limit
  ) {
    ...ScheduleExportTask
    schedulePhase {
      id
    }
    scheduleSubPhase {
      id
    }
  }
}
    ${ScheduleExportPhasesFragmentDoc}
${ScheduleExportSubPhaseFragmentDoc}
${ScheduleExportTaskFragmentDoc}`;

/**
 * __useScheduleExportPageQuery__
 *
 * To run a query within a React component, call `useScheduleExportPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduleExportPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduleExportPageQuery({
 *   variables: {
 *      scheduleId: // value for 'scheduleId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      tradePartnerIds: // value for 'tradePartnerIds'
 *      scheduleSubPhaseIds: // value for 'scheduleSubPhaseIds'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useScheduleExportPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ScheduleExportPageQuery, ScheduleExportPageQueryVariables> & ({ variables: ScheduleExportPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ScheduleExportPageQuery, ScheduleExportPageQueryVariables>(ScheduleExportPageDocument, options);
      }
export function useScheduleExportPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ScheduleExportPageQuery, ScheduleExportPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ScheduleExportPageQuery, ScheduleExportPageQueryVariables>(ScheduleExportPageDocument, options);
        }
// @ts-ignore
export function useScheduleExportPageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ScheduleExportPageQuery, ScheduleExportPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ScheduleExportPageQuery, ScheduleExportPageQueryVariables>;
export function useScheduleExportPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ScheduleExportPageQuery, ScheduleExportPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ScheduleExportPageQuery | undefined, ScheduleExportPageQueryVariables>;
export function useScheduleExportPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ScheduleExportPageQuery, ScheduleExportPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ScheduleExportPageQuery, ScheduleExportPageQueryVariables>(ScheduleExportPageDocument, options);
        }
export type ScheduleExportPageQueryHookResult = ReturnType<typeof useScheduleExportPageQuery>;
export type ScheduleExportPageLazyQueryHookResult = ReturnType<typeof useScheduleExportPageLazyQuery>;
export type ScheduleExportPageSuspenseQueryHookResult = ReturnType<typeof useScheduleExportPageSuspenseQuery>;
export type ScheduleExportPageQueryResult = Apollo.QueryResult<ScheduleExportPageQuery, ScheduleExportPageQueryVariables>;